// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils__JsonPlus from "@pageblocks/utils/src/jsonPlus/Utils__JsonPlus.bs.js";
import * as Renderer__Accessor from "./Renderer__Accessor.bs.js";

var decodeString = Core__JSON.Decode.string;

var decodeFloat = Core__JSON.Decode.$$float;

var decodeBool = Core__JSON.Decode.bool;

var decodeObject = Core__JSON.Decode.object;

var decodeArray = Core__JSON.Decode.array;

function string(prim) {
  return prim;
}

function $$float(prim) {
  return prim;
}

function bool(prim) {
  return prim;
}

function array(prim) {
  return prim;
}

function object(prim) {
  return prim;
}

function classify(setting) {
  var v = Core__JSON.Classify.classify(setting);
  if (typeof v !== "object") {
    return "Null";
  }
  switch (v.TAG) {
    case "Bool" :
        return {
                TAG: "Bool",
                _0: v._0
              };
    case "String" :
        return {
                TAG: "String",
                _0: v._0
              };
    case "Number" :
        return {
                TAG: "Float",
                _0: v._0
              };
    case "Object" :
        return {
                TAG: "Object",
                _0: v._0
              };
    case "Array" :
        return {
                TAG: "List",
                _0: v._0
              };
    
  }
}

var fromPath = Renderer__Accessor.Path.serialize;

function get(settings, key) {
  return Core__Option.flatMap(Core__JSON.Decode.object(settings), (function (__x) {
                return __x[key];
              }));
}

function addEntries(settings, entries) {
  return Utils__JsonPlus.addEntries(settings, entries);
}

function entries(settings) {
  return Core__Option.map(Core__JSON.Decode.object(settings), (function (prim) {
                return Object.entries(prim);
              }));
}

function makeEmpty() {
  return null;
}

function toJson(prim) {
  return prim;
}

function fromJson(prim) {
  return prim;
}

function ValueJSON_toJson(prim) {
  return prim;
}

function ValueJSON_fromJson(prim) {
  return prim;
}

var ValueJSON = {
  decodeString: decodeString,
  decodeFloat: decodeFloat,
  decodeBool: decodeBool,
  decodeObject: decodeObject,
  decodeArray: decodeArray,
  string: string,
  $$float: $$float,
  bool: bool,
  array: array,
  object: object,
  classify: classify,
  fromPath: fromPath,
  toJson: ValueJSON_toJson,
  fromJson: ValueJSON_fromJson
};

export {
  toJson ,
  fromJson ,
  ValueJSON ,
  get ,
  addEntries ,
  entries ,
  makeEmpty ,
}
/* No side effect */
